"use client";
import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { useRouter } from "next/navigation";
import { PuffLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { RootState } from "../src/redux/store";
import { logout, setUser } from "../src/redux/features/auth/authSlice";
import { useAppDispatch } from "../src/redux/hooks";

export default function LoginButton() {
  const [loadingUser, setLoadingUser] = useState(false);
  const [loggingOut, setLoggingOut] = useState(false);
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { isAuthenticated, loading, error } = useSelector(
    (state: RootState) => state.auth
  );

  useEffect(() => {
    // Hardcoded user - always authenticated
    dispatch(setUser({
      id: 'hardcoded-user-123',
      email: 'user@example.com',
      user_metadata: {
        firstName: 'John',
        lastName: 'Doe',
      },
      full_name: 'John Doe',
    }));
    setLoadingUser(false);
  }, [dispatch]);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      dispatch(logout({ router }));
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      setLoggingOut(false);
    }
  };

  if (loadingUser) {
    return <PuffLoader />;
  }

  if (isAuthenticated) {
    return (
      <Button
        className="transition-transform transform hover:scale-105"
        onClick={() => {
          handleLogout();
        }}
      >
        {loggingOut ? "Logging out..." : "Log out"}
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      className="text-black transition-transform transform hover:scale-105"
      onClick={() => {
        router.push("/login");
      }}
    >
      Login
    </Button>
  );
}